import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-cambio-pwd',
  templateUrl: './cambio-pwd.component.html',
  styleUrls: ['./cambio-pwd.component.css']
})
export class CambioPwdComponent implements OnInit {
  theme:string="";
  inter:any;
  @Input() timer:number;
  @Input() titulo:string;
  @Input() texto1:string;
  @Input() texto2:string;
  @Input() texto3:string;
  @Input() tipo:string;
  @Input() btn1:string = "";
  @Input() btn2:string = "";
  @Input() btn3:string = "";
  iniTimer:number;
  esError:boolean=false;

  result:any;
  okPwdActual:boolean;
  okPwdNueva:boolean;
  okPwdConfirma:boolean;

  msgErrPwdActual:string="";
  msgErrPwdNueva:string="";
  msgErrPwdConfirma:string="";

  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 2300;
  loading:boolean=false;


  thisFormPwd = new FormGroup({
    pwdActual: new FormControl("", [Validators.required]),
    pwdNueva: new FormControl("", [Validators.required, Validators.minLength(5)]),
    pwdConfirma: new FormControl("", [Validators.required, Validators.minLength(5)]),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<CambioPwdComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    setTimeout(() => {
      this.fnCargaPopUp();
    }, 10);
    if(this.data){
        //console.log(this.data)
        this.timer = this.data.timer;
        this.titulo = this.data.titulo;
        this.texto1 = this.data.texto1;
        if(this.titulo.toUpperCase().indexOf("NO VÁLIDO") > 0)
          this.esError=true;
        this.iniTimer = this.texto1.indexOf(">|t|<")
        this.texto2 = this.data.texto2;
        this.texto3 = this.data.texto3;
        this.tipo = this.data.tipo; 
        this.btn1 = this.data.btn1;
        this.btn2 = this.data.btn2;
        this.btn3 = this.data.btn3;
    }
    else{
        this.timer = 25;
        this.titulo = "Atención"
        this.texto1 = `Parrafo1.`;
        this.texto2 = `Parrafo2.`;
        this.texto3 = `...`;
    }
  }
  
  onChange(): void {
    //console.log("onChange");
  }

  fnClick(operacion){
    console.log("click: " + operacion)
    if(operacion.toUpperCase() == "CONTINUAR"){
      this.dialogRef.close(operacion);
    }
    if(operacion.toUpperCase() == "ENTERADO"){
      this.dialogRef.close(operacion);
    }

  }

  ngOnDestroy(){
    clearInterval(this.inter);
    this.inter = null;    
  }

  fnCargaPopUp(){
    if(this.tipo=="CAMBIA PWD"){
      //console.log("Mostrar Formulario")
    }
    if(this.timer > 0){
      this.inter = setInterval(()=>{
        this.timer--;
        //console.log(this.timer);
        if (this.timer == 0){
          this.dialogRef.close('CERRADO');
        }
      },1000)
    }
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnValidaPwdActual(){
    //console.log(this.thisFormPwd.controls["pwdActual"].value);
    var auxP = CryptoJS.MD5(this.thisFormPwd.controls["pwdActual"].value).toString();
    this.dataService.getLogin(this.dataService.getCurrentUsr() ,auxP).subscribe(
                          row => { this.result = <any>row; },
                          error => this.errMsg = <any>error,
                          () => this.fnLoginProbado()
                        );
  }

  fnLoginProbado(){
    //console.log(this.result);
    if(this.result.length>0){
      if(this.result[0].idu == this.dataService.getCurrentUsr()){
        this.okPwdActual = true;
        this.msgErrPwdActual = ""  
      }
      else{
        this.okPwdActual = false;
        this.msgErrPwdActual = "* No coincide"  
      }
    }
    else{
      this.okPwdActual = false;
      this.msgErrPwdActual = "* No coincide"
    }
  }

  fnValidaPwdNueva(){
    //console.log(this.thisFormPwd.controls["pwdNueva"].value);
    this.msgErrPwdNueva = "";
    if(this.thisFormPwd.controls["pwdNueva"].errors){
      if(this.thisFormPwd.controls["pwdNueva"].errors.required){
        this.msgErrPwdNueva="* Campo requerido";
        this.okPwdNueva = false;
        //this.fnMuestraMensaje("ERR", "Capture la 'nueva contraseña' que usará para ingresar al sistema.", true, false);
        return;
      }
      if(this.thisFormPwd.controls["pwdNueva"].errors.minlength){
        //console.log(this.thisFormPwd.controls["pwdNueva"].errors.minlength.actualLength);
        if(this.thisFormPwd.controls["pwdNueva"].errors.minlength.actualLength < this.thisFormPwd.controls["pwdNueva"].errors.minlength.requiredLength){
          this.msgErrPwdNueva="* Longitud mínima: " + this.thisFormPwd.controls["pwdNueva"].errors.minlength.requiredLength + " caracteres";
          this.okPwdNueva = false;
          //this.fnMuestraMensaje("ERR", "La 'nueva contraseña' debe contener " + this.thisFormPwd.controls["pwdNueva"].errors.minlength.requiredLength + " o más caracteres.", true, false)
        }
        this.okPwdNueva = false;
        return;
      }
    }
    var auxP = CryptoJS.MD5(this.thisFormPwd.controls["pwdNueva"].value).toString();
    this.dataService.isSameUsuarioPwd(this.dataService.getCurrentUsr() ,auxP).subscribe(
                                                row => { this.result = <any>row; },
                                                error => this.errMsg = <any>error,
                                                () => this.fnNuevaProbada()
                                              );
    if(this.okPwdConfirma){
      if(this.thisFormPwd.controls["pwdConfirma"].value != this.thisFormPwd.controls["pwdNueva"].value){
        this.msgErrPwdConfirma="* No coincide la confirmación";
        this.okPwdConfirma = false;
      }
      else{
        this.okPwdConfirma = true;
      }
    }
  }

  fnNuevaProbada(){
    console.log(this.result);
    if(this.result == 1){  //--> Diferente = 1
      this.okPwdNueva = true;
      this.msgErrPwdNueva = "";  
    }
    else{
      this.okPwdNueva = false;
      this.msgErrPwdNueva = "* Contraseña nueva debe ser distinta";  
    }
  }

  fnValidaPwdConfirma(){
    //console.log(this.thisFormPwd.controls["pwdConfirma"].value);
    this.msgErrPwdConfirma = "";
    if(this.thisFormPwd.controls["pwdConfirma"].errors){
      if(this.thisFormPwd.controls["pwdConfirma"].errors.required){
        this.msgErrPwdConfirma="* Campo requerido";
        this.okPwdConfirma = false;
        //this.fnMuestraMensaje("ERR", "Capture la 'nueva contraseña' que usará para ingresar al sistema.", true, false);
        return;
      }
      if(this.thisFormPwd.controls["pwdConfirma"].errors.minlength){
        //console.log(this.thisFormPwd.controls["pwdConfirma"].errors.minlength.actualLength);
        if(this.thisFormPwd.controls["pwdConfirma"].errors.minlength.actualLength < this.thisFormPwd.controls["pwdConfirma"].errors.minlength.requiredLength){
          this.msgErrPwdConfirma="* Longitud mínima: " + this.thisFormPwd.controls["pwdConfirma"].errors.minlength.requiredLength + " caracteres";
          this.okPwdConfirma = false;
          //this.fnMuestraMensaje("ERR", "La 'nueva contraseña' debe contener " + this.thisFormPwd.controls["pwdNueva"].errors.minlength.requiredLength + " o más caracteres.", true, false)
        }
        this.okPwdConfirma = false;
        return;
      }
    }
    //console.log(this.thisFormPwd.controls["pwdConfirma"].value + " != " + this.thisFormPwd.controls["pwdNueva"].value);
    if(this.thisFormPwd.controls["pwdConfirma"].value != this.thisFormPwd.controls["pwdNueva"].value){
      this.msgErrPwdConfirma="* No coincide la confirmación";
      this.okPwdConfirma = false;
    }
    else{
      this.okPwdConfirma = true;
    }
  }

  fnGuardar(){
    if(!this.okPwdActual){
      this.fnMuestraMensaje("ERR", "Valide la información de la 'contraseña actual'", false, false)
      return;
    }
    if(!this.okPwdNueva){
      this.fnMuestraMensaje("ERR", "Valide la información de la 'nueva contraseña'", false, false)
      return;
    }
    if(!this.okPwdConfirma){
      this.fnMuestraMensaje("ERR", "Valide la 'comprobación de la contraseña'", false, false)
      return;
    }
    var auxP = CryptoJS.MD5(this.thisFormPwd.controls["pwdNueva"].value).toString();
    this.dataService.updUsuarioPwd(this.dataService.getCurrentUsr(), auxP).subscribe(
                                                row => { this.result = <any>row; },
                                                error => this.errMsg = <any>error,
                                                () => this.fnContraseñaCambiada()
                                              );
  }

  fnContraseñaCambiada(){
    //console.log(this.result);
    if(this.result == 1){
      this.fnMuestraMensaje("OK", "Cambio de contraseña exitoso", false, true)
    }
    else{
      this.fnMuestraMensaje("ERR", "Ocurrió un error al cambiar la contraseña'", false, false)
    }
  }

}

